// Usage just import dateHelpers in any file and supply required argument
import moment from 'moment'
import tz from 'moment-timezone'
import platform from 'platform'
export const dateHelpers = {
    // never called deprecated one
    deprecated: () => {
        return tz
    },
    userPlatForm: () => {
        return platform
    },
    // @date Date required
    dstEnabled: (date) => {
        // return moment(date).isDST()
        let timeZone = 'America/New_York'
        return moment(date).tz(timeZone).isDST()
    },
    getUserTimeZone: () => {
        var tz = moment.tz.guess()
        return tz
    },
    // @date Date required
    // @timezone Date optional default to 'America/New_York'
    returnEasternTime: (date, timezone) => {
        let timeZone = timezone || 'America/New_York'
        return moment(date).tz(timeZone).toString()
    },
    returnFormattedEasternDateTime: () => {
        let timeZone = 'America/New_York'
        return moment(new Date()).tz(timeZone).format('MM/DD/YYYY HH:mm:SS').toString()
    },
    returnFormattedUTCDateTime: () => {
        return moment.utc(new Date()).format('MM/DD/YYYY HH:mm:SS').toString()
    },
    // @firstDate Date required
    // @secondDate Date optional default to current Date
    getDatesDifference: (firstDate, secondDate, type) => {
        let timeZone = 'America/New_York'
        let first = moment(firstDate).tz(timeZone)
        first.set({hour: 0, minute: 0, second: 0, millisecond: 0})
        let second = moment(secondDate).tz(timeZone)
        second.set({hour: 0, minute: 0, second: 0, millisecond: 0})
        switch (type) {
        case 'minutes': {
            return first.diff(second, 'minutes')
        }
        case 'hours': {
            return first.diff(second, 'hours')
        }
        case 'days': {
            // console.log('trial end date', first)
            // console.log('current date', second)
            return first.diff(second, 'days') + 1
        }
        case 'weeks': {
            return first.diff(second, 'weeks')
        }
        default :return first.diff(second, 'days')
        }
    }
}



// WEBPACK FOOTER //
// ./src/helpers/dateHelpers.js